
import Vue from 'vue';
import AOS from 'aos';
import CareersTeam from './page-sections/CareersTeam.vue';
import CareersBenefits from './page-sections/CareersBenefits.vue';
import CareersCulture from './page-sections/CareersCulture.vue';
import CareersSchedule from './page-sections/CareersSchedule.vue';
import CareersInBravado from './page-sections/CareersInBravado.vue';
import AboutUsMap from '~/components/partials/landings/about-us/page-sections/AboutUsMap.vue';
import Footer from '~/components/global/Footer/Footer.vue';
import Header from '~/components/global/Header/Header.vue';

import 'aos/dist/aos.css';

export default Vue.extend({
  name: 'Careers',
  components: {
    Header,
    Footer,
    CareersTeam,
    CareersBenefits,
    CareersCulture,
    CareersSchedule,
    AboutUsMap,
    CareersInBravado,
  },
  mounted() {
    AOS.init();
  },
});
